import { RootState } from "store/index";
import { createSelector } from "@reduxjs/toolkit";
import { DisplayMenuLoop } from "models/menu/menuLoop";

const editingMenuLoop = (state: RootState): DisplayMenuLoop =>
  state.menuLoopDetail.menuLoop;

const editingMenuLoopSpecialDates = createSelector(
  [editingMenuLoop],
  (data) => data.skip_dates,
);

const getEditingMenuLoopSpecialDate = createSelector(
  [editingMenuLoopSpecialDates],
  (data) => (key: string) => (!data ? null : data[key]),
);

const isLoading = (state: RootState): boolean => state.menuLoopDetail.isLoading;

const isSaving = (state: RootState): boolean => state.menuLoopDetail.isSaving;

const isCopying = (state: RootState): boolean => state.menuLoopDetail.isCopying;

const error = (state: RootState): string | null | undefined =>
  state.menuLoopDetail.error;

export default {
  editingMenuLoop,
  editingMenuLoopSpecialDates,
  getEditingMenuLoopSpecialDate,
  isLoading,
  isSaving,
  isCopying,
  error,
};
